module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Demographics")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "content": _vm.demographicsDescription[_vm.selectedDemographicType],
      "placement": "bottom-start",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-fw fa-info-circle",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Channel",
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.demographicType),
      callback: function($$v) {
        _vm.demographicType = $$v
      },
      expression: "demographicType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "fans"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('loader', {
    attrs: {
      "message": "Loading demographics",
      "shadow": "none"
    }
  })], 1) : _c('div', {
    staticClass: "card-content"
  }, [(!_vm.hasData) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": _vm.facebookPage ? 'No data' : 'No channel connected'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "insights-container"
  }, _vm._l((_vm.demographicData), function(value, key) {
    return _c('DemographicsItem', {
      key: key,
      staticClass: "insight-item",
      attrs: {
        "data": value,
        "label": key
      }
    })
  }), 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90cf6e02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/PageDemographicsOverview.vue
// module id = 3368
// module chunks = 3